import { RichText } from "components/slices/RichText";
import { SMALL } from "shared/variables";
import { SrcSet } from "components/SrcSet";
import { Button } from "components/Button";
import styles from "./CardWithImage.module.css";

export const CardWithImageWrapper = ({ primary }) => {
  const { image, link, link_label, text, title } = primary;

  return (
    <CardWithImage
      image={{ src: image.url, alt: image.alt }}
      link={link}
      linkLabel={link_label}
      text={text}
      title={title}
    />
  );
};

export const CardWithImage = ({ image, link, linkLabel, text, title }) => (
  <div className={styles.container}>
    {image?.src && (
      <SrcSet
        className={styles.image}
        alt={image.alt}
        src={image.src}
        sizes={[
          { minWidth: 768, width: 128, ratio: 1 },
          { minWidth: 1, width: 96, ratio: 1 },
        ]}
      />
    )}
    <div>
      <RichText size={SMALL}>
        <h3>{title}</h3>
        <p>{text}</p>
      </RichText>
      {link && (
        <div className={styles.linkContainer}>
          <Button link={link} size={SMALL}>
            {linkLabel}
          </Button>
        </div>
      )}
    </div>
  </div>
);
